import store from "@/plugins/vuex";

const searchParams = {
  page: 0,
  maxPerPage: 10,
  sort: 'name',
};

export async function loadCorporations() {
  try {
    const { data } = await store.dispatch('corporations/listCorporations', { ...searchParams });
    store.commit('corporations/setCorporations', data.filter((el) => el.status === 'active'));
    return { success: true };
  } catch (e) {
    store.commit('corporations/setCorporations', []);
    return { error: e, errorType: 'fetch corporations', code: e.status.code };
  }
}

export async function checkIfHasLocalCorporation() {
  const localCorporation = localStorage.getItem('corporationName');
  const isAdmin = store.getters['users/getIsAdmin'];

  if (isAdmin) return;

  if (!localCorporation) {
    const prefilledCorporation = this.getCorporationsList[0];
    store.commit('corporations/setLocalCorporation', prefilledCorporation);
    return;
  }

  try {
    const { data } = await store.dispatch(
      'corporations/findCorporationByName',
      { ...this.searchParams, name: localCorporation }
    );

    if (data.length) {
      const prefilledCorporation = data.find((el) => el.name === localCorporation);
      store.commit('corporations/setLocalCorporation', prefilledCorporation);
    }
  } catch (e) {
    const prefilledCorporation = this.getCorporationsList[0];
    store.commit('corporations/setLocalCorporation', prefilledCorporation);
    return;
  }
}

export function setSelectedCorporationId(id) {
  const isAdmin = store.getters['users/getIsAdmin'];

  if (id && isAdmin) {
    store.commit('corporations/setCorporationId', id);
  }
}